module.exports = __webpack_public_path__ + "static/media/amazon-it.ea2cfbc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/amazon-it.jpg
// module id = 1129
// module chunks = 0